import { render } from "./History.vue?vue&type=template&id=b32c1cb4"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__